export function header() {
  const headerEl = document.querySelector(".main-header");
  const announcementEl = document.querySelector("[data-announcement]");
  const headerButtons = headerEl.querySelector("[data-header-button-group]");
  const overlayMenu = headerEl.querySelector("[data-overlay-menu]");

  let headerTopOffset = 0;

  function updateHeaderClass() {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 0 && headerTopOffset === 0) {
      headerEl.classList.replace("main-header--top", "main-header--not-top");
    } else {
      headerEl.classList.replace("main-header--not-top", "main-header--top");
    }

    if (scrollPosition >= 100) {
      headerEl.classList.add("main-header--scrolled");
    } else {
      headerEl.classList.remove("main-header--scrolled");
    }
  }

  function onFirstScroll() {
    headerEl.classList.add("main-header--ready");
    window.removeEventListener("scroll", onFirstScroll);
  }

  if (document.readyState === "interactive") updateHeaderClass();

  window.addEventListener("scroll", onFirstScroll);
  window.addEventListener("scroll", updateHeaderClass);

  announcement();

  function announcement() {
    if (!announcementEl) return;

    let announcementHeight;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        announcementHeight = entry.target.offsetHeight;
      }
      updateElementsPosition();
    });

    const updateElementsPosition = () => {
      const scrolled = window.scrollY;
      headerTopOffset = Math.max(0, announcementHeight - scrolled);
      if (headerButtons) headerButtons.style.top = `${headerTopOffset}px`;
      if (overlayMenu) overlayMenu.style.top = `${headerTopOffset}px`;
    };

    resizeObserver.observe(announcementEl);
    window.addEventListener("scroll", updateElementsPosition);
  }
}